export default "/images/fceae8e8698640f871f899709e7cf8da.jpg";